<div *ngIf="trainingMode" class="training-mode-banner">
  {{ 'training.bannerText' | transloco }}
</div>
